export default __webpack_public_path__ + "static/media/kitchen5-beforeB-1024w.763c7b58.avif";